import { Link } from 'react-router-dom';
import './HomePage.css';
import { useEffect, useState } from 'react';
import Navbar from '../Navbar/Navbar';
import SEO from '../SEO';

const HomePage = () => {
    const [showPrivacyPopup, setShowPrivacyPopup] = useState(false);

    useEffect(() => {
        const privacyAccepted = localStorage.getItem('privacyAccepted');
        if (privacyAccepted !== 'true') {
            setTimeout(() => {
                setShowPrivacyPopup(true);
            }, 1000);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('privacyAccepted', 'true');
        setShowPrivacyPopup(false);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="home-redesign">
            <SEO
                title="Free Video Chat with Strangers | No Sign-Up Required"
                description="Instant video chat with strangers worldwide. 100% anonymous & secure."
                url="https://chatlea.com"
            />

            {/* Privacy Popup */}
            {showPrivacyPopup && (
                <div className="privacy-popup-overlay-redesign">
                    <div className="privacy-popup-redesign">
                        <h3>Your Privacy & Security</h3>
                        <div className="privacy-item">
                            <div className="privacy-icon">
                                <i className="fas fa-shield-alt"></i>
                            </div>
                            <div className="privacy-text">
                                <strong>No personal data collected:</strong> We don't require or store any personal information.
                            </div>
                        </div>
                        <div className="privacy-item">
                            <div className="privacy-icon">
                                <i className="fas fa-lock"></i>
                            </div>
                            <div className="privacy-text">
                                <strong>End-to-end encrypted:</strong> Your video chats are private and secure.
                            </div>
                        </div>
                        <div className="privacy-item">
                            <div className="privacy-icon">
                                <i className="fas fa-ban"></i>
                            </div>
                            <div className="privacy-text">
                                <strong>No data sharing:</strong> We never share your information with third parties.
                            </div>
                        </div>
                        <div className="privacy-buttons">
                            <button
                                className="btn btn-primary"
                                onClick={handleAccept}
                            >
                                <i className="fas fa-check"></i>
                                I Understand & Continue
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <Navbar />

            {/* Hero Section */}
            <section className="hero-section-redesign">
                <div className="hero-bg-pattern"></div>
                <div className="hero-container">
                    <div className="hero-content-left">
                        <div className="hero-badge">
                            <i className="fas fa-bolt"></i>
                            Instant Connection • No Sign-Up Required
                        </div>
                        <h1 className="hero-title">
                            Connect With<br />
                            <span style={{ background: 'linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                                Real People
                            </span>
                        </h1>
                        <p className="hero-subtitle">
                            Experience genuine connections through secure, anonymous video chats with people from around the world. Start talking in seconds, no account needed.
                        </p>
                        <div className="hero-cta-buttons">
                            <Link to="/chat" className="btn btn-primary">
                                <i className="fas fa-video"></i>
                                Start Video Chat
                            </Link>
                            <a href="#features" className="btn btn-secondary">
                                <i className="fas fa-play-circle"></i>
                                See How It Works
                            </a>
                        </div>
                    </div>
                    <div className="hero-content-right">
                        <div className="video-chat-demo">
                            <div className="demo-header">
                                <div className="demo-dot"></div>
                                <div className="demo-dot"></div>
                                <div className="demo-dot"></div>
                                <div className="demo-title">Live Video Chat</div>
                            </div>
                            <div className="demo-video-grid">
                                <div className="video-frame local">
                                    <div className="video-user">
                                        <div className="user-avatar-large">
                                            <i className="fas fa-user"></i>
                                        </div>
                                        <div className="user-name-large">You</div>
                                    </div>
                                </div>
                                <div className="video-frame remote">
                                    <div className="video-user">
                                        <div className="user-avatar-large">
                                            <i className="fas fa-user-friends"></i>
                                        </div>
                                        <div className="user-name-large">Partner</div>
                                    </div>
                                </div>
                            </div>
                            <div className="connection-pulse">
                                <i className="fas fa-wifi"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Section */}
            <section className="stats-section">
                <div className="stats-grid">
                    <div className="stat-item">
                        <div className="stat-number">10K+</div>
                        <div className="stat-label">Active Users</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-number">50+</div>
                        <div className="stat-label">Countries</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-number">24/7</div>
                        <div className="stat-label">Live Support</div>
                    </div>
                    <div className="stat-item">
                        <div className="stat-number">99.9%</div>
                        <div className="stat-label">Uptime</div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section id="features" className="features-section-redesign">
                <div className="section-header">
                    <div className="section-subtitle">Why Choose Us</div>
                    <h2 className="section-title">Experience the Best Video Chat Platform</h2>
                    <p className="section-description">
                        Designed with privacy and user experience in mind, our platform offers everything you need for meaningful connections.
                    </p>
                </div>
                <div className="features-grid-redesign">
                    <div className="feature-card-redesign">
                        <div className="feature-icon-redesign">
                            <i className="fas fa-shield-alt"></i>
                        </div>
                        <h3>Military-Grade Security</h3>
                        <p>End-to-end encryption ensures your conversations remain private and secure from any third parties.</p>
                        <a href="/" className="feature-link">
                            Learn more <i className="fas fa-arrow-right"></i>
                        </a>
                    </div>
                    <div className="feature-card-redesign">
                        <div className="feature-icon-redesign">
                            <i className="fas fa-bolt"></i>
                        </div>
                        <h3>Lightning Fast</h3>
                        <p>Optimized servers worldwide provide low latency connections for crystal clear conversations.</p>
                        <a href="/" className="feature-link">
                            See speed test <i className="fas fa-arrow-right"></i>
                        </a>
                    </div>
                    <div className="feature-card-redesign">
                        <div className="feature-icon-redesign">
                            <i className="fas fa-globe-americas"></i>
                        </div>
                        <h3>Global Community</h3>
                        <p>Connect with people from diverse backgrounds and cultures across 50+ countries.</p>
                        <a href="/" className="feature-link">
                            Explore community <i className="fas fa-arrow-right"></i>
                        </a>
                    </div>
                    <div className="feature-card-redesign">
                        <div className="feature-icon-redesign">
                            <i className="fas fa-heart"></i>
                        </div>
                        <h3>Safe Environment</h3>
                        <p>Advanced moderation and reporting tools ensure a safe and respectful environment for everyone.</p>
                        <a href="/" className="feature-link">
                            Safety guidelines <i className="fas fa-arrow-right"></i>
                        </a>
                    </div>
                </div>
            </section>

            {/* How It Works */}
            <section className="how-it-works-redesign" id="how-it-works">
                <div className="section-header">
                    <div className="section-subtitle">Simple Process</div>
                    <h2 className="section-title">Start Chatting in 4 Easy Steps</h2>
                    <p className="section-description">
                        Get connected with interesting people in less than a minute. No complicated setup required.
                    </p>
                </div>
                <div className="timeline-container">
                    <div className="timeline-step">
                        <div className="step-content">
                            <div className="step-number-redesign">1</div>
                            <h3>Click Start Chat</h3>
                            <p>Simply click the "Start Video Chat" button. No registration or personal information required.</p>
                        </div>
                    </div>
                    <div className="timeline-step">
                        <div className="step-content">
                            <div className="step-number-redesign">2</div>
                            <h3>Allow Permissions</h3>
                            <p>Grant camera and microphone access. We only use them during your active chat sessions.</p>
                        </div>
                    </div>
                    <div className="timeline-step">
                        <div className="step-content">
                            <div className="step-number-redesign">3</div>
                            <h3>Find Your Match</h3>
                            <p>Our smart algorithm instantly connects you with compatible partners based on preferences.</p>
                        </div>
                    </div>
                    <div className="timeline-step">
                        <div className="step-content">
                            <div className="step-number-redesign">4</div>
                            <h3>Start Conversation</h3>
                            <p>Begin your video chat! Use text chat alongside video if you prefer to type sometimes.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials */}
            <section className="testimonials-redesign" id="testimonials">
                <div className="section-header">
                    <div className="section-subtitle">User Stories</div>
                    <h2 className="section-title">What Our Users Say</h2>
                    <p className="section-description">
                        Join thousands of satisfied users who've made meaningful connections through our platform.
                    </p>
                </div>
                <div className="testimonials-grid">
                    <div className="testimonial-card-redesign">
                        <div className="quote-icon">
                            <i className="fas fa-quote-left"></i>
                        </div>
                        <div className="testimonial-text">
                            "I was skeptical at first, but this platform changed how I meet people online. The video quality is exceptional and I've made friends from three different continents!"
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar-redesign">
                                SJ
                            </div>
                            <div className="author-info">
                                <h4>Sarah Johnson</h4>
                                <p>Digital Nomad • 6 months on platform</p>
                            </div>
                        </div>
                    </div>
                    <div className="testimonial-card-redesign">
                        <div className="quote-icon">
                            <i className="fas fa-quote-left"></i>
                        </div>
                        <div className="testimonial-text">
                            "As someone who works remotely, this app has been a game-changer for social interaction. The privacy features give me peace of mind while connecting with interesting people."
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar-redesign">
                                MT
                            </div>
                            <div className="author-info">
                                <h4>Michael Torres</h4>
                                <p>Software Developer • 4 months on platform</p>
                            </div>
                        </div>
                    </div>
                    <div className="testimonial-card-redesign">
                        <div className="quote-icon">
                            <i className="fas fa-quote-left"></i>
                        </div>
                        <div className="testimonial-text">
                            "The cultural exchange I've experienced is priceless. From learning Japanese phrases to discussing philosophy with a professor from Italy - it's been an incredible journey."
                        </div>
                        <div className="testimonial-author">
                            <div className="author-avatar-redesign">
                                AK
                            </div>
                            <div className="author-info">
                                <h4>Aisha Khan</h4>
                                <p>Language Student • 8 months on platform</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Final CTA */}
            <section className="final-cta-redesign">
                <div className="cta-container">
                    <h2>Ready to Start Your Journey?</h2>
                    <p>
                        Join our growing community of users who are making genuine connections every day. 
                        Experience the future of social interaction today.
                    </p>
                    <div className="cta-buttons-centered">
                        <Link to="/chat" className="btn btn-primary">
                            <i className="fas fa-video"></i>
                            Start Free Video Chat
                        </Link>
                        <a href="#how-it-works" className="btn btn-secondary">
                            <i className="fas fa-info-circle"></i>
                            Learn More
                        </a>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="footer-redesign">
                <div className="footer-content-redesign">
                    <div className="footer-logo-section">
                        <div className="footer-logo-redesign">
                            <img src={process.env.PUBLIC_URL + '/logo.png'} alt="VideoChat Logo" />
                        </div>
                        <p className="footer-description">
                            Connecting people through secure, anonymous video chats since 2023. 
                            Our mission is to foster genuine human connections across the globe.
                        </p>
                        <div className="footer-social-redesign">
                            <a href="https://www.instagram.com/chatlea__" target="_blank" rel="noopener noreferrer" className="social-icon-redesign">
                                <i className="fab fa-instagram"></i>
                            </a>
                            <a href="/" className="social-icon-redesign">
                                <i className="fab fa-twitter"></i>
                            </a>
                            <a href="/" className="social-icon-redesign">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href="/" className="social-icon-redesign">
                                <i className="fab fa-linkedin-in"></i>
                            </a>
                        </div>
                    </div>
                    <div className="footer-links-grid">
                        <div className="footer-links-group">
                            <h3>Platform</h3>
                            <a href="#features">Features</a>
                            <a href="#how-it-works">How It Works</a>
                            <a href="#testimonials">Testimonials</a>
                            <a href="/chat">Live Demo</a>
                        </div>
                        <div className="footer-links-group">
                            <h3>Legal</h3>
                            <Link to="/PrivacyPolicy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Service</Link>
                            <a href="/">Cookie Policy</a>
                            <a href="/">Community Guidelines</a>
                        </div>
                        <div className="footer-links-group">
                            <h3>Support</h3>
                            <a href="/">Help Center</a>
                            <a href="/">Safety Tips</a>
                            <a href="/">Contact Us</a>
                            <a href="/">FAQ</a>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    © {new Date().getFullYear()} Chatlea. All rights reserved. Made with <i className="fas fa-heart" style={{color: '#ec4899', margin: '0 5px'}}></i> for global connection.
                </div>
            </footer>
        </div>
    );
};

export default HomePage;